import { useUser } from "../../controllers/UserController";
import useWootingUser from "../../utils/hooks/useWootingUser";
import EditNameModal from "./EditNameModal";
import ProfileImage from "./ProfileImage";
import { useLingui } from "@lingui/react";
import {
  EMAIL_LABEL,
  FIRST_NAME_LABEL,
  LAST_NAME_LABEL,
  NO_PHONE_NUMBBER_LABEL,
  PHONENUMBER_LABEL,
} from "../../utils/constants/i18n-strings";
import {
  Text,
  Grid,
  HStack,
  Label,
  VStack,
} from "@wootingkb/component-library";
import {
  RegionalInstanceCapability,
  useRegionalInstanceCapability,
} from "../../lib/[services]/regional-instance";

export default function UserDetails() {
  const { data: user } = useUser();
  const [wootingUser] = useWootingUser();
  const { first_name, last_name } = wootingUser?.customer_name ?? {};
  const { _: i18n } = useLingui();
  const showPhoneOTP = useRegionalInstanceCapability(
    RegionalInstanceCapability.PhoneOTP
  );

  return (
    <HStack className="h-fit w-full gap-8">
      <ProfileImage />
      <Grid className="relative w-full grid-cols-2 gap-4">
        <VStack>
          <Label>{i18n(FIRST_NAME_LABEL)}</Label>
          <Text weight="semibold" className="rb-mask">
            {first_name}
          </Text>
        </VStack>
        <VStack>
          <Label>{i18n(LAST_NAME_LABEL)}</Label>
          <Text weight="semibold" className="rb-mask">
            {last_name}
          </Text>
        </VStack>
        {user?.email.endsWith("@temp.invalid") ? (
          <></>
        ) : (
          <>
            <VStack>
              <Label>{i18n(EMAIL_LABEL)}</Label>
              <Text weight="semibold" className="rb-mask">
                {user?.email}
              </Text>
            </VStack>
            <VStack>
              {
                // spaces the phonenumber to below email instead of next to it
              }
            </VStack>
          </>
        )}
        {showPhoneOTP && user?.phoneNumber ? (
          <VStack>
            <Label>{i18n(PHONENUMBER_LABEL)}</Label>
            <Text weight="semibold" className="rb-mask">
              {user.phoneNumber}
            </Text>
          </VStack>
        ) : (
          <></>
        )}
        {/** Leaving this in - but this was commented out 4 years ago from this commit and will likely be removed in the future */}
        {/* <FormControl>
              <Flex>
                <Checkbox
                  id="marketing-checkbox"
                  name="marketing-checkbox"
                  mr=".5rem"
                  defaultIsChecked={true}
                />
                <Label
                  htmlFor="marketing-checkbox"
                  opacity=".8"
                  fontSize=".7rem"
                  m="0"
                  userSelect="none"
                >
                  I would like to stay updated and receive marketing
                  emails
                </Label>
              </Flex>
            </FormControl> */}
        <EditNameModal
          userName={
            wootingUser?.customer_name ?? { first_name: "", last_name: "" }
          }
        />
      </Grid>
    </HStack>
  );
}
